import { useMemo } from 'react';

interface OriginImageListProps {
  image_list: OriginImageSize[];
}

interface OriginImageSize {
  origin_width: number | null;
  origin_height: number | null;
}

export type ImageHeightRatio = 1 | 1.2 | 1.3;

export const useFirstImageHeightRatio = ({ image_list }: OriginImageListProps) => {
  const first_image_height_ratio = useMemo<ImageHeightRatio>(() => {
    const DEFAULT_RATIO = 1;

    if (!image_list.length) {
      return DEFAULT_RATIO;
    }

    const first_image = image_list[0];
    const origin_width = first_image.origin_width ?? 0;
    const origin_height = first_image?.origin_height ?? 0;
    const vertical_ratio = origin_height / origin_width;

    if (vertical_ratio <= 1.1) {
      return DEFAULT_RATIO;
    }

    if (vertical_ratio < 1.3) {
      return 1.2;
    }

    if (1.3 <= vertical_ratio) {
      return 1.3;
    }

    return DEFAULT_RATIO;
  }, [image_list]);

  return {
    first_image_height_ratio,
  };
};
